
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle, Wifi, Database, ShieldAlert } from "lucide-react";
import { ErrorCategory } from '@/utils/errorHandler';

interface ConnectionErrorAlertProps {
  message?: string;
  description?: string;
  category?: ErrorCategory;
}

export const ConnectionErrorAlert: React.FC<ConnectionErrorAlertProps> = ({
  message = "Connection error",
  description = "Unable to connect to the database. Please check your internet connection or try again later.",
  category = ErrorCategory.NETWORK
}) => {
  const getIcon = () => {
    switch (category) {
      case ErrorCategory.NETWORK:
        return <Wifi className="h-4 w-4 text-amber-800" />;
      case ErrorCategory.DATABASE:
        return <Database className="h-4 w-4 text-amber-800" />;
      case ErrorCategory.AUTHENTICATION:
      case ErrorCategory.AUTHORIZATION:
        return <ShieldAlert className="h-4 w-4 text-amber-800" />;
      default:
        return <AlertTriangle className="h-4 w-4 text-amber-800" />;
    }
  };

  return (
    <Alert variant="default" className="bg-amber-50 border-amber-200">
      {getIcon()}
      <AlertTitle className="text-amber-800">{message}</AlertTitle>
      <AlertDescription className="text-amber-700">
        {description}
      </AlertDescription>
    </Alert>
  );
};

export default ConnectionErrorAlert;
